import type { ButtonProps} from '@chakra-ui/react'
import { Button, Text } from '@chakra-ui/react'
import { Link } from 'react-router'

import { useStepsContext } from '../../context/StepsContext'
import { StepNumber } from './StepNumber'

export interface StepProps extends Omit<ButtonProps, 'id'> {
  children?: React.ReactNode
  id: number
  title: string
  path: string
  isCurrent?: boolean
  isPassed?: boolean
  isLast?: boolean
  isContentHidden?: boolean
}

export const Step = ({
  id,
  title,
  path,
  isDisabled,
  isCurrent = false,
  isPassed = false,
  isLast = false,
  isContentHidden = false,
}: StepProps) => {
  const { onNavigate } = useStepsContext()

  let bgColor = 'transparent'
  let color = 'step-bg'

  if (isCurrent) {
    bgColor = 'step-current-bg'
    color = 'white'
  } else if (isPassed) {
    color = 'step-bg'
  }

  const btnProps = !isDisabled
    ? {
      as: Link,
      to: path,
    }
    : {}

  return (
    <Button
      {...btnProps}
      as={Link}
      onClick={(e) => onNavigate?.(e)}
      variant="unstyled"
      isDisabled={isDisabled}
      sx={{
        w: '100%',
        position: 'relative',
        display: 'flex',
        justifyContent: { base: 'center', xl: 'start' },
        px: { base: 2, md: 4, xl: 8 },
        py: 3,
        gap: { base: 0, md: 4, xl: 8 },
        bgColor,
        borderRadius: 0,
        color,
        _after: {
          content: isLast || isCurrent ? 'none' : '""',
          position: 'absolute',
          top: 2,
          left: '100%',
          bgColor: 'step-divider-bg',
          opacity: 0.2,
          w: 'px',
          h: 12,
        },
      }}
    >
      <StepNumber
        isCurrent={isCurrent}
        isPassed={isPassed}
        sx={{ visibility: isContentHidden ? 'hidden' : 'unset' }}
      >
        {id}
      </StepNumber>

      <Text
        sx={{
          display: {
            base: 'none',
            md: isCurrent ? 'initial' : 'none',
            lg: 'initial',
          },
          color: 'inherit',
          whiteSpace: 'nowrap',
          visibility: isContentHidden ? 'hidden' : 'unset',
        }}
      >
        {title}
      </Text>
    </Button>
  )
}
